import { SelectionPermission } from 'store/productManagement/reducer.types';

export const getValueRequiredPermissionDisplayValue = (selectedPermission: string): string[] => {
  if (selectedPermission === SelectionPermission.DEFAULT_VALUE) {
    return ['Default value(s)'];
  }

  if (selectedPermission === SelectionPermission.FIXED_VALUE) {
    return ['Defined value(s)'];
  }

  return [];
};

export const getNoRestrictionsDisplayValue = (selectedPermission?: string): string[] => {
  if (selectedPermission === SelectionPermission.ALL_OPTIONS) {
    return ['No restrictions'];
  }

  if (selectedPermission === SelectionPermission.DISABLED) {
    return ['Not in product'];
  }

  return [];
};
